const initialState = {
    newsItems: null,
    newsLoading: false,
    menuItems: null,
    menuLoading: false,
    welcomeItems: null,
    welcomeLoading: false,
    birthdayItems: null,
    birthdayLoading: false,
    babyItems: null,
    babyLoading: false,
    motdItems: null,
    motdLoading: false,
    reportSubmitting: false,
    reportSubmitted: false,
    reportFailed: false,

    adminMenuItems:null,
    adminMenuLoading:false,
};

export default (state = initialState, action) => {

    const {type, payload} = action;

    switch (type) {

        //ADMIN MENU
        case "ADMIN_MENU_LOADING":
            state = {
                ...state,
                adminMenuItems:[],
                adminMenuLoading: true
            };
            return state;
        case "ADMIN_MENU_SUCCESS":
            state={
                ...state,
                adminMenuLoading: false,
                adminMenuItems: payload
            };
            return state;
        case "ADMIN_MENU_FAILURE":
            state={
                ...state,
                adminMenuItems:[],
                adminMenuLoading: false
            };
            return state;


        // --------
        // Menus
        
        case "MENU_RESET":
            return initialState;

        case "MENU_LOADING":
            state = {
                ...state,
                menuLoading: true
            };
            return state;

        case "MENU_SUCCESS":
            state={
                ...state,
                menuLoading: false,
                menuItems: payload
            };
            return state;

        case "MENU_FAILURE":
            state={
                ...state,
                menuLoading: false
            };
            return state;

        // --------
        // Report form
        case 'REPORT_RESET':
            state = {
                ...state,
                reportSubmitting: false,
                reportSubmitted: false,
                reportFailed: false
            }
            return state;

        case 'REPORT_SUBMITTING' :
            state = {
                ...state,
                reportSubmitting: true
            }
            return state;

        case 'REPORT_SUCCESS' :
            state = {
                ...state,
                reportSubmitting: false,
                reportSubmitted: true,
                reportFailed: false
            }
            return state;

        case 'REPORT_FAILED' :
            state = {
                ...state,
                reportSubmitting: false,
                reportSubmitted: false,
                reportFailed: true
            }
            return state;

        //-------------
        case "NEWS_RESET":
            return initialState;

        case "NEWS_LOADING":
            state = {
                ...state,
                newsLoading:true
            };
            return state;

        case "NEWS_SUCCESS":
            state={
                  ...state,
                newsLoading:false,
                newsItems:payload
            };
            return state;

        case "NEWS_FAILURE":
            state={
                ...state,
                newsLoading:false
            };
            return state;

        //-------------
        // Welcome
        case "WELCOME_RESET":
            return initialState;

        case "WELCOME_LOADING":
            state = {
                ...state,
                welcomeLoading:true
            };
            return state;

        case "WELCOME_SUCCESS":
            state={
                ...state,
                welcomeLoading:false,
                welcomeItems:payload
            };
            return state;

        case "WELCOME_FAILURE":
            state={
                ...state,
                welcomeLoading:false
            };
            return state;

        //-------------
        // Birthday
        case "BIRTHDAY_RESET":
            return initialState;

        case "BIRTHDAY_LOADING":
            state = {
                ...state,
                birthdayLoading:true
            };
            return state;

        case "BIRTHDAY_SUCCESS":
            state={
                ...state,
                birthdayLoading:false,
                birthdayItems:payload
            };
            return state;

        case "BIRTHDAY_FAILURE":
            state={
                ...state,
                birthdayLoading:false
            };
            return state;

        //-------------
        // Baby
        case "BABY_RESET":
            return initialState;

        case "BABY_LOADING":
            state = {
                ...state,
                babyLoading:true
            };
            return state;

        case "BABY_SUCCESS":
            state={
                ...state,
                babyLoading:false,
                babyItems:payload
            };
            return state;

        case "BABY_FAILURE":
            state={
                ...state,
                babyLoading:false
            };
            return state;

        
        //-------------
        // MOTD
        case "MOTD_RESET":
            return initialState;

        case "MOTD_LOADING":
            state = {
                ...state,
                motdLoading:true
            };
            return state;

        case "MOTD_SUCCESS":
            state={
                ...state,
                motdLoading:false,
                motdItems:payload
            };
            return state;

        case "MOTD_FAILURE":
            state={
                ...state,
                motdLoading:false
            };
            return state; 
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/frontend/store/reducers/psagot.js